.option {
  display: var(--haus-checkoutCheckbox__option__display, flex);
  align-items: var(--haus-checkoutCheckbox__option__align-items, center);
  gap: var(--haus-checkoutCheckbox__option__gap, 8px);
  cursor: var(--haus-checkoutCheckbox__option__cursor, pointer);
}

.optionLabel {
  font-size: var(
    --haus-checkoutCheckbox__optionLabel__font-size,
    var(--haus-typography-body-font-size, 1rem)
  );
  font-weight: var(
    --haus-checkoutCheckbox__optionLabel__font-weight,
    var(--haus-typography-body-font-weight, 400)
  );
  line-height: var(
    --haus-checkoutCheckbox__optionLabel__line-height,
    var(--haus-typography-body-line-height, 1.5)
  );
  color: var(--haus-checkoutCheckbox__optionLabel__color, var(--haus-color-text, #000));
  font-family: var(
    --haus-checkoutCheckbox__optionLabel__font-family,
    var(--haus-typography-body-font-family, 'Inter, sans-serif')
  );
  cursor: var(--haus-checkoutCheckbox__optionLabel__cursor, pointer);
}

.input {
  width: var(--haus-checkoutCheckbox__input__width, 16px);
  height: var(--haus-checkoutCheckbox__input__height, 16px);
  accent-color: var(--haus-checkoutCheckbox__input__accent-color, var(--haus-color-primary, #000));
  cursor: var(--haus-checkoutCheckbox__input__cursor, pointer);
}

.error {
  color: var(--haus-checkoutCheckbox__error__color, var(--haus-color-error, #dc3545));
  font-size: var(--haus-checkoutCheckbox__error__font-size, 0.875rem);
  margin-top: var(--haus-checkoutCheckbox__error__margin-top, 8px);
}
